import ArrowLeft from "@mui/icons-material/ArrowLeft"
import ArrowRight from "@mui/icons-material/ArrowRight"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import CardHeader from "@mui/material/CardHeader"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import TextField from "@mui/material/TextField"
import { useConfirm } from "material-ui-confirm"
import React, { useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { phaseDelete, phaseUpdate } from "../store/actions"
import { selectServicesByPhaseId } from "../store/reducers/servicePackageServiceReducer"
import { SelectServiceDialog } from "./selectServiceDialog"
import { ServicePackageService } from "./ServicePackageService"

const styles = {
	root: {
		"& .MuiTextField-root": {
			margin: 10,
			width: 250,
		},
	},
}

const PhaseCard = ({ phaseObj, index, packageId }) => {
	const dispatch = useDispatch()
	const confirm = useConfirm()

	const servicePackageServices = useSelector((state) => selectServicesByPhaseId(state, phaseObj.phaseid), shallowEqual)
	const servicePackageServicesMemo = useMemo(() => servicePackageServices, [servicePackageServices])
	const phases = useSelector((state) => state.phases, shallowEqual)
	const phasesMemo = useMemo(() => (phases ? phases : []), [phases])

	const pDelete = (id) => dispatch(phaseDelete(id))
	const pUpdate = (json, id) => dispatch(phaseUpdate(json, id))

	const [ssdOpen, setSsdOpen] = useState(false)

	return (
		<>
			<Card raised={true} sx={{ margin: 1, width: 300 }}>
				<CardHeader
					title={phaseObj.title}
					action={
						<>
							{index === 0 && <ArrowLeft color="secondary" />}
							{index !== 0 && (
								<ArrowLeft
									onClick={() => {
										let temp = phasesMemo[index].phaseorder
										pUpdate({ phaseorder: phasesMemo[index - 1].phaseorder }, phasesMemo[index].phaseid)
										pUpdate({ phaseorder: temp }, phasesMemo[index - 1].phaseid)
									}}
									cursor={"pointer"}
								/>
							)}
							{typeof phasesMemo[index + 1] === "undefined" && <ArrowRight color="secondary" />}
							{typeof phasesMemo[index + 1] !== "undefined" && (
								<ArrowRight
									onClick={() => {
										let temp = phasesMemo[index].phaseorder
										pUpdate({ phaseorder: phasesMemo[index + 1].phaseorder }, phasesMemo[index].phaseid)
										pUpdate({ phaseorder: temp }, phasesMemo[index + 1].phaseid)
									}}
									cursor={"pointer"}
								/>
							)}
							<DeleteForeverIcon
								onClick={() => {
									confirm({
										title: "Haluatko poistaa vaiheen?",
										description:
											"Tämä poistaa vaiheen ja siihen liittyvät tiedot. Toimintoa ei voi peruuttaa tietokanta tallennuksen jälkeen.",
										confirmationText: "Kyllä",
										cancellationText: "Peruuta",
									})
										.then(() => pDelete(phaseObj.phaseid))
										.catch(() => console.log("Cancelled"))
								}}
								cursor={"pointer"}
							/>
						</>
					}
				/>
				<CardContent sx={{ ...styles, display: "flex", flexDirection: "column" }}>
					<TextField
						label="Järjestys"
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						type="number"
						id={"phphaseorder" + index}
						disabled
						value={phaseObj.phaseorder}></TextField>

					<TextField
						label="Otsikko"
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						id={"ptitle" + phaseObj.phaseid}
						onBlur={(e) => pUpdate({ title: e.target.value }, phaseObj.phaseid)}
						defaultValue={phaseObj.title === null ? "" : phaseObj.title}></TextField>
					<TextField
						label="Kuvaus"
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						id={"pdescription" + phaseObj.phaseid}
						onBlur={(e) => pUpdate({ description: e.target.value }, phaseObj.phaseid)}
						defaultValue={phaseObj.description === null ? "" : phaseObj.description}></TextField>

					<TextField
						label="Tarkka Kuvaus"
						InputLabelProps={{ shrink: true }}
						variant="outlined"
						multiline
						id={"plongdescription" + phaseObj.phaseid}
						onBlur={(e) => pUpdate({ longdescription: e.target.value }, phaseObj.phaseid)}
						defaultValue={phaseObj.longdescription === null ? "" : phaseObj.longdescription}></TextField>
					<List>
						{servicePackageServicesMemo.length > 0 &&
							servicePackageServicesMemo.map((servicePackage) => {
								return (
									<ServicePackageService
										key={`${phaseObj.phaseid}${servicePackage.serviceid}`}
										servicePackage={servicePackage}
									/>
								)
							})}
					</List>
					<Divider />
					<Button color="primary" onClick={() => setSsdOpen(true)}>
						Lisää Palvelu
					</Button>
				</CardContent>
			</Card>
			<SelectServiceDialog
				isOpen={ssdOpen}
				onCloseFunc={() => {
					setSsdOpen(false)
				}}
				spId={packageId}
				phase={phaseObj.phaseid}
			/>
		</>
	)
}
export default PhaseCard
